import axios, { AxiosError } from "axios";
import { MessageInstance } from "antd/es/message/interface";
import i18n from "@/plugins/i18n";
import { ResponseCode, responseCodeToI18nKey } from "@/domains/common";

const getResponseErrorI18nKey = (errorCode: ResponseCode) => {
  const excludedErrorCodes = [
    ResponseCode.Success,
    ResponseCode.NoAuthorizationHeader,
    ResponseCode.InvalidAuthorizationHeader,
    ResponseCode.InvalidAccessToken,
    ResponseCode.InvalidUser,
  ];

  if (!excludedErrorCodes.includes(errorCode))
    return responseCodeToI18nKey[errorCode];
};

export const ErrorHelper = {
  isAxiosError(error: unknown): error is AxiosError<HttpResponse<unknown>> {
    return axios.isAxiosError(error);
  },
  isHandledByAxiosInterceptors(error: AxiosError<HttpResponse<unknown>>) {
    const res = error.response;
    return (
      res?.status === 401 ||
      error.code === "ERR_NETWORK" ||
      (res && res?.status >= 500)
    );
  },
  async handleAxiosErrorMessage(
    error: AxiosError<HttpResponse<unknown>>,
    messageApi: MessageInstance,
  ) {
    const res = error.response;

    // 無回傳資料 => 顯示預設訊息
    if (!res) {
      await messageApi.error(i18n.t("systems.Error.requestError"));
      return;
    }

    // 500 已被 axios interceptors 處理
    if (this.isHandledByAxiosInterceptors(error)) {
      return;
    }

    const { err, msg } = res.data;

    // 處理特定錯誤碼
    if (err !== undefined) {
      const i18nKey = getResponseErrorI18nKey(err);
      if (i18nKey) {
        await messageApi.error(i18n.t("systems.ResponseError." + i18nKey));
        return;
      }
    }

    // 有回傳資料且 msg 為字串 => 顯示回傳訊息
    if (typeof msg === "string") {
      await messageApi.error(msg);
      return;
    }

    // 有回傳資料但 msg 格式不是字串 => 轉成字串來顯示
    await messageApi.error(JSON.stringify(msg));
  },
};
